define([
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!sumo/actions/Constants',
], (Immutable, _, Util, Constants) => {
  const initialState = Immutable.fromJS({
    tiers: Immutable.List(),
    cartId: null,
    upsellAppId: null,
    hideBasicOption: false,
    hideGrowthOption: false,
    loading: false,
    sumoDiscountCode: null,
    features: Immutable.Map(),
    featuresLoaded: false,
    upsellFeature: '',
    upgradePreview: Immutable.Map(),
    showUpgrade: false,
    addOnSites: 0,
    upsellSlug: '',
    couponCode: null,
  });

  const actionHandlers = {};

  // Trigger the pricing upsell modal render if user clicks on a pro feature that they don't have
  actionHandlers[Constants.SUMOME_UPSELL] = (state, action) => {
    const {
      appId,
      hideBasicOption,
      internalSource,
      upsellSlug,
      hideGrowthOption,
      couponCode,
    } = action;

    return state.merge({
      upsellAppId: appId,
      hideBasicOption: !!hideBasicOption,
      internalSource,
      upsellSlug,
      hideGrowthOption,
      couponCode,
    });
  };

  actionHandlers[Constants.SET_UPGRADE_PREVIEW] = (state, { upgradePreview }) => (
    state.update('upgradePreview', (currentPreview) => currentPreview.merge(upgradePreview))
  );

  actionHandlers[Constants.SET_SHOW_UPGRADE] = (state, { show }) => (
    state.set('showUpgrade', show)
  );

  actionHandlers[Constants.UPDATE_APP_STORE_SETTING] = (state, action) => (
    state.setIn([action.code], action.value)
  );

  actionHandlers[Constants.SUMOME_UPSELL_LOADING] = (state) => (
    state.setIn(['loading'], true)
  );

  actionHandlers[Constants.RECEIVE_SUMOMEPRO_OPTIONS] = (state, action) => {
    const tiers = action.tiers || {};

    const {
      sumomeProOptions,
      sumomeProCollectionId: collectionId,
      sumomeProCartId,
    } = tiers;

    const newOptions = (sumomeProOptions || []).map((option) => (
      { ...option, collectionId }
    ));

    const nextState = state.setIn(['loading'], false)
      .set('tiers', Immutable.fromJS(newOptions));

    if (!sumomeProCartId) return nextState;
    return nextState.set('cartId', sumomeProCartId);
  };

  actionHandlers[Constants.SET_FEATURES] = (state, { features }) => {
    if (!features || !Object.keys(features).length) return state;

    return state.merge({
      features: Immutable.Map(features),
      featuresLoaded: true,
    });
  };

  actionHandlers[Constants.RECEIVE_PRICING_TABLE] = (state, { pricingTableHTML }) => (
    state
      .set('pricingTableHTML', pricingTableHTML)
      .set('loading', false)
  );

  return Util.createReducer(initialState, actionHandlers);
});
